<template>
  <TsColumn dataTestid="column-cart">
    <NuxtLinkWithLocale
        id="header-cart-link"
        :data-testid="
        props?.dataTestid
          ? props.dataTestid + '_header-cart'
          : '_header-link-cart'
      "
        to="/trolley"
        class="hover:text-natural-light-grey cursor-pointer flex flex-col items-end lg:items-center"
    >
      <span class="relative size-[22px]">
        <TsIcon
            name="ci:shopping-cart-02"
            :size="isDesktop ? '22' : '28'"
        ></TsIcon>
        <span
            v-if="trolleyStore.total_products"
            :class="{
            'absolute grid place-content-center -top-1 border border-white bg-primary-hover rounded-full size-[16px] lg:size-[16px] p-0.5 leading-[8px] text-white text-[10px] font-semibold': true,
            'px-2 -right-2': trolleyStore.total_products <= 99,
            'px-3 -right-4': trolleyStore.total_products > 99,
          }"
            data-testid="trolley-item-count"
        >
          {{ trolleyStore.total_products }}
        </span>
      </span>
      <TsTypography
          v-if="isDesktop"
          as="span"
          variant="sm"
          appendClass="leading-[12px] text-idle-white hidden lg:block lg:mt-2"
      >
        {{ useTranslation("trolley", "Winkelwagen") }}
      </TsTypography>
    </NuxtLinkWithLocale>
  </TsColumn>
</template>
<script setup lang="ts">
import { useTranslation } from "~/composables/useTranslation";

const { isDesktop } = useDevice();

const trolleyStore = useTrolleyStore();

type Props = {
  dataTestid?: string;
};

const props = withDefaults(defineProps<Props>(), {});
</script>
